var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import get from 'lodash.get';
import React, { Fragment, useEffect } from 'react';
import { useApolloClient } from 'react-apollo';
import { useHistory } from 'react-router';
import { getActiveFiltersFromSearch } from '../../resolvers/filters/filterParams';
const mockCategory = {
    name: '',
    url: '',
    products: { result: [], totalResults: 0, filters: [] }
};
function getCategory(result) {
    const routeObject = get(result, 'data.route.object');
    const dataCategory = get(result, 'data.category');
    return {
        category: routeObject || dataCategory || mockCategory,
        cacheHit: !!(routeObject || dataCategory)
    };
}
function useFiltersOnHistoryPop() {
    const client = useApolloClient();
    useEffect(() => {
        function getSearchFilters() {
            // Write the active filters from search
            client.writeData({
                data: {
                    activeFilters: getActiveFiltersFromSearch(window.location.search)
                }
            });
        }
        return window.addEventListener('popstate', getSearchFilters, false);
    }, [client]);
}
const CategoryRoute = (props) => {
    const { component: CategoryPage } = props, rest = __rest(props, ["component"]);
    const { category, cacheHit } = getCategory(props.result);
    const history = useHistory();
    useFiltersOnHistoryPop();
    useEffect(() => {
        if (category.name.length > 0) {
            history.replace(history.location.pathname +
                history.location.search +
                history.location.hash, Object.assign({ list: category.name }, history.location.state));
        }
    }, [category.id, category.name, history]);
    return (React.createElement(Fragment, null,
        React.createElement(CategoryPage, Object.assign({}, rest, { category: category, cacheHit: cacheHit }))));
};
export default CategoryRoute;
//# sourceMappingURL=CategoryRoute.js.map